__turbopack_context__.v({
  "SContentWrapper": "bSZLSW_SContentWrapper",
  "SSectionParagraphTitle": "bSZLSW_SSectionParagraphTitle",
  "SSectionSubTitle": "bSZLSW_SSectionSubTitle",
  "SSectionTitle": "bSZLSW_SSectionTitle",
});
